import {useAuthStore} from "@/store/auth";
import examinerRoute from "./examinerRoute";
import schoolRoute from "./schoolRoute";
import scoresRoute from "./scoresRoute";
import auth from "./auth";
export default [
  ...auth,
  ...examinerRoute,
  ...schoolRoute,
  ...scoresRoute,
  {
    path: "/",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dashboard"),
  },
  {
    path: "/default",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
          next({name: "dashboard"});
          // Continue to the login page
        
      },
    },
    component: () => import("../views/dashboard/default.vue"),
  },
  {
    path: "/menu-res",
    name: "menu",
    meta: {
      title: "Menu List",
      authRequired: true,
      // acc: "admin",
    },
    component: () => import("../views/settings/menu-list"),
  },
  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("../views/notfound/404-cover"),
  },
  // start of import
 {
    path:  '/:pathMatch(.*)*',
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("../views/notfound/404-cover"),
  },
  // end of import
];
